import { DislikedOfferIdsListDto } from '@wwt/entities/api/search-response'

export const dislikeKeys = {
	base: ['dislike'] as const,
	all: () => [...dislikeKeys.base, 'get'] as const,

	/**
	 * Mutations
	 */
	create: () => [...dislikeKeys.base, 'create'] as const,
	delete: () => [...dislikeKeys.base, 'delete'] as const
}

export interface DislikeTypes {
	all: DislikedOfferIdsListDto
}

export interface DislikeKeys {
	all: ReturnType<typeof dislikeKeys.all>
}
